import { getNode, getNodes } from '@gravityforms/utils';

export default {
	buttons: {
		begin: getNode( 'gform-conversational-nav-begin' ),
		next: getNode( 'gform-conversational-nav-next' ),
		prev: getNode( 'gform-conversational-nav-prev' ),
		allNextButtons: getNodes( 'gform-conversational-nav-field-next' ),
		allSubmitButtons: getNodes( 'gform-conversational-nav-field-submit' ),
	},
	fields: getNodes( '.gfield:not(.gfield_visibility_hidden):not(.gfield--type-hidden):not(.gform_hidden)', true, document, true ),
	formNav: getNode( 'gform-conversational-nav' ),
	formNavButtons: getNode( 'gform-conversational-nav-buttons' ),
	conversationalForm: getNode( 'gform-conversational-form' ),
	form: getNode( '.gform_wrapper form', document, true ),
	inputs: {
		pageTarget: getNode( '[name^="gform_target_page_number_"]', document, true ),
		pageSource: getNode( '[name^="gform_source_page_number_"]', document, true ),
	},
	logo: getNode( 'gform-conversational-logo' ),
	progressBar: getNode( 'gform-conversational-progress-bar' ),
	progressBarInner: getNode( 'gform-conversational-progress-bar-inner' ),
	progressBarLabel: getNode( 'gform-conversational-progress-bar-label' ),
	root: getNode( 'gform-conversational' ),
	welcomeScreen: getNode( 'gform-conversational-welcome-screen' ),
	welcomeScreenElements: getNodes( 'gform-welcome-screen-element', true, document ),
	fieldInputs: [],
};
